var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIconColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6531 10.1082C14.4002 10.1082 14.0665 10.1731 13.7117 10.4278C13.6836 10.4489 10.8083 12.553 10.8083 13.7052L10.8119 13.7736C10.9453 16.4942 13.0003 19.8594 16.9206 23.7795C20.8392 27.6979 24.2045 29.7528 26.9251 29.8881L26.9708 29.8898C26.9831 29.8898 26.9954 29.8916 27.0077 29.8916C28.1845 29.8916 30.2518 27.0165 30.2728 26.9884C30.805 26.2419 30.6118 25.4077 30.1288 25.0634C29.8144 24.8263 26.4913 22.6502 26.0856 22.4078C25.65 22.1584 25.0528 22.2058 24.5206 22.5255C24.2045 22.6976 23.2191 23.2614 22.7624 23.5249C22.355 23.2438 21.3573 22.4886 19.8029 20.9044C18.2432 19.3465 17.4722 18.3454 17.1788 17.9344C17.444 17.4743 18.0061 16.4907 18.1835 16.164C18.5014 15.5827 18.5383 14.982 18.2819 14.5974C18.0535 14.2162 15.8369 10.8511 15.6367 10.5736C15.4576 10.3207 15.1519 10.1538 14.8024 10.1169C14.7567 10.1117 14.7076 10.1082 14.6531 10.1082Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIconColor);
export default __webpack_public_path__ + "static/media/callIconColor.bf8af4243f639fe6a1cd4a97a7e14014.svg";
export { ForwardRef as ReactComponent };